export enum ProtocolTypes {
    NAVIGATE_TO_UE = 'NAVIGATE_TO_UE',
    OPEN_ADD_FRIENDS = 'OPEN_ADD_FRIENDS',
    OPEN_ADD_FRIEND_REQUESTS = 'OPEN_ADD_FRIEND_REQUESTS',
    OPEN_ADD_FRIEND_SUGGESTIONS = 'OPEN_ADD_FRIEND_SUGGESTIONS',
    OPEN_ADD_FRIEND_CONNECTIONS = 'OPEN_ADD_FRIEND_CONNECTIONS',
    OPEN_SETTINGS = 'OPEN_SETTINGS',
    OPEN_SOCIAL_PANEL = 'OPEN_SOCIAL_PANEL'
}

// @depreciated
export const TYPES = ProtocolTypes;

export interface ProtocolAction {
    type: ProtocolTypes;
}

export default {
    // @depreciated
    TYPES,

    navigateToUe: (): ProtocolAction => ({
        type: ProtocolTypes.NAVIGATE_TO_UE
    }),

    openAddFriends: (): ProtocolAction => ({
        type: ProtocolTypes.OPEN_ADD_FRIENDS
    }),

    openAddFriendRequests: (): ProtocolAction => ({
        type: ProtocolTypes.OPEN_ADD_FRIEND_REQUESTS
    }),

    openAddFriendSuggestions: (): ProtocolAction => ({
        type: ProtocolTypes.OPEN_ADD_FRIEND_SUGGESTIONS
    }),

    openAddFriendConnections: (): ProtocolAction => ({
        type: ProtocolTypes.OPEN_ADD_FRIEND_CONNECTIONS
    }),

    openSettings: (): ProtocolAction => ({
        type: ProtocolTypes.OPEN_SETTINGS
    }),

    openSocialPanel: (): ProtocolAction => ({
        type: ProtocolTypes.OPEN_SOCIAL_PANEL
    })
};
